export default "__VITE_ASSET__Be_G$Zhy__"